const body = document.querySelector('body')
const hamburger = document.querySelector('.hamburger')
const nav = document.querySelector('.nav')

hamburger.addEventListener('click', openNav)

function openNav() {
  nav.classList.toggle('open')
  nav.classList.contains('open') ? body.style.overflow = 'hidden' :  body.style.overflow = 'auto'
}

const nav_items = document.querySelectorAll('.nav_item')

nav_items.forEach(item => {
  item.addEventListener('click', () => {
    body.style.overflow = 'auto'
    nav.classList.remove('open')
  })
})